import router from './router'

// 输出模块
export default router




// WEBPACK FOOTER //
// ./src/router/index.js